import { render } from "./journal.vue?vue&type=template&id=a1c97e72&scoped=true&ts=true"
import script from "./journal.vue?vue&type=script&lang=ts"
export * from "./journal.vue?vue&type=script&lang=ts"

import "./journal.vue?vue&type=style&index=0&id=a1c97e72&lang=scss"
import "./journal.vue?vue&type=style&index=1&id=a1c97e72&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1c97e72"]])

export default __exports__